import { useState, useEffect, useRef } from 'react';

export default function useDropdownVisible(initialIsVisible: boolean) {
    const [isDropdownVisible, setIsDropdownVisible] = useState(initialIsVisible);
    const ref = useRef(null);

    const handleClickOutside = (event: { target: any; }) => {
        {/* @ts-ignore */}
        if (ref.current && !ref.current.contains(event.target)) {
            setIsDropdownVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    return { ref, isDropdownVisible, setIsDropdownVisible };
}
